import { routes } from 'router';

// Quick Quote Journey
export const routePageMapQuote = {
  [routes.personalDetails]: 'vodapay: vodalend compare: personal details',
  [routes.loanRequest]: 'vodapay: vodalend compare: borrow details',
  [routes.offers]: 'vodapay: vodalend compare: loan offers',
};

export const routeLinkMapQuote = {
  [routes.personalDetails]: 'vodapay: vodalend compare: personal details: back',
  [routes.loanRequest]: 'vodapay: vodalend compare: borrow details: back',
  [routes.offers]: 'vodapay: vodalend compare: loan offers: back',
};

export const routeServiceNameMapQuote = {
  [routes.personalDetails]: 'vodalend compare: landing page: quick quote: personal details',
  [routes.loanRequest]: 'vodalend compare: landing page: quick quote: borrow details',
  [routes.offers]: 'vodalend compare: quick quote: product select',
};
